import React from "react";
import BreadCrumb from "../../../layout/BreadCrumb";
import Header from "./Header";
import CardFarmer from "./CardFarmer";
import FarmerDetails from "./FarmerDetails";

function FarmerViewList() {
  return ( 
  <div className="min-h-[88vh] flex flex-col">  
      <BreadCrumb
        breadcrumbs={[
          { title: "Farmers", path: "/farmers-list" },
          { title: "Farmer View" },
        ]}
      />
      <Header />
      <CardFarmer />
      <FarmerDetails />
    </div>
  );
}

export default FarmerViewList;
